import React from "react"
import styled from "@emotion/styled"
import { Box, Link as ThemeLink } from "theme-ui"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const PressBox = styled(Box)`
    max-width: 350px;
    height: auto;
    background: ${(props) => props.theme.colors.primary};
    box-shadow: rgba(0, 0, 0, 0.24) 4px 5px 8px;
    position: relative;
    flex: 0 0 350px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover img {
        transform: scale(1.3);
    }

    & .image-round {
        display: inline-block;
        position: relative;
        // width: 200px;
        height: auto;
        overflow: hidden;

        & img {
            width: auto;
            height: 100%;

            transition: transform 0.5s;
        }
        & img:hover {
            transform: scale(1.3);
        }
        //
    }

    & p {
        margin: 2rem;
        margin: 1rem auto;
        color: ${(props) => props.theme.colors.background};
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            font-size: 14px;
        }
    }
    & h3 {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        word-break: break-word;
        color: ${(props) => props.theme.colors.background};
        margin: 0.5rem;
        font-weight: 500;
    }
    & .team-content {
        width: 100%;
        padding: 0 1rem;
        margin-bottom: 1.5rem;
    }
    & .arrow-wrapper {
        flex: 0 0 20%;
        & .arrow,
        .arrow:before,
        .arrow:after {
            background-color: ${(props) => props.theme.colors.background};
        }
    }
    & a {
        display: flex;
        width: 100%;
        margin-top: auto;
        padding: 0.7rem 1rem;
        color: ${(props) => props.theme.colors.background};
        text-decoration: none;

        &:hover {
            text-decoration: none;
            transition: all 0.3s linear;
            & .arrow-wrapper {
                transition: all 0.3s linear;
                flex: 0 0 30%;
            }
            & .arrow {
                transition: all 0.3s linear;
                width: 4rem !important;
                @media screen and (max-width: ${(props) =>
                        props.theme.breakpoints[3]}) {
                    width: 3rem !important;
                }
            }
        }
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        height: auto;
        margin: 1rem 0;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        flex: 0 0 250px;
        & .arrow-wrapper {
            flex: 0 0 28%;
        }
    }
`

const Cards = ({ title, url, imageFile }) => {
    return (
        <PressBox
        // onMouseEnter={() => mouseHoverHandler(idx)}
        // onMouseLeave={mouseLeaveHandler}
        >
            <div className="image-round">
                <GatsbyImage image={getImage(imageFile)} alt={title} />
            </div>
            <ThemeLink href={url} target="_blank" rel="noreferrer">
                <div className="arrow-wrapper">
                    <div className="arrow"></div>
                </div>
                <span>{title}</span>
            </ThemeLink>
        </PressBox>
    )
}

export default Cards
